import React from 'react';
import SearchResultRibbon from '../search/searchResultRibbon';
import SearchResultsManager from '../search/searchResultsManager';

class SearchResultsHeader extends React.Component {
    render() {
        return (<>
            <SearchResultRibbon {...this.props} />
            { !this.props.isMobile && <SearchResultsManager {...this.props} /> }
        </>)
    }
}

export default SearchResultsHeader;